const finitePositive = (value, label) => {
  const number = Number(value);
  if (!Number.isFinite(number) || number <= 0) {
    throw new Error(`${label} must be a positive number.`);
  }
  return number;
};
export const normalizeSceneAssetLayer = (value) => (
  String(value || '').toLowerCase() === 'gamemaster' ? 'gamemaster' : 'token'
);

/** Size presentation art to one grid cell on its longest edge while retaining
 * the decoded image aspect ratio. date_of_change: 2026-09-11 */
export const getSceneAssetInitialSize = ({ intrinsicWidth, intrinsicHeight, gridSize }) => {
  const width = finitePositive(intrinsicWidth, 'Image width');
  const height = finitePositive(intrinsicHeight, 'Image height');
  const longEdge = finitePositive(gridSize, 'Grid size');
  const scale = longEdge / Math.max(width, height);
  return { width: width * scale, height: height * scale };
};

/** Build the strict client command body using map-local coordinates. Placement
 * does not inspect actor occupancy because scene art is non-mechanical.
 * date_of_change: 2026-09-11 */
export const buildSceneAssetCreatePayload = ({
  asset,
  layer,
  placement,
  intrinsicSize,
  gridSize,
  mapSize,
  snapToGrid = false,
}) => {
  const sourceAssetId = String(asset?.id || '').trim();
  if (!sourceAssetId) throw new Error('Choose a ready image from the asset vault before placing it.');
  const size = getSceneAssetInitialSize({
    intrinsicWidth: intrinsicSize?.width,
    intrinsicHeight: intrinsicSize?.height,
    gridSize,
  });
  const mapWidth = finitePositive(mapSize?.width, 'Map width');
  const mapHeight = finitePositive(mapSize?.height, 'Map height');
  const centerX = Number(placement?.x);
  const centerY = Number(placement?.y);
  if (!Number.isFinite(centerX) || !Number.isFinite(centerY)) throw new Error('Choose a valid map location for this image.');
  const snap = (value) => snapToGrid ? Math.round(value / gridSize) * gridSize : value;
  const x = Math.min(Math.max(snap(centerX - (size.width / 2)), 0), mapWidth);
  const y = Math.min(Math.max(snap(centerY - (size.height / 2)), 0), mapHeight);

  return {
    sourceAssetId,
    name: String(asset?.name || 'Scene image').slice(0, 80),
    layer: normalizeSceneAssetLayer(layer),
    x,
    y,
    width: size.width,
    height: size.height,
    rotation: 0,
    opacity: 1,
    locked: false,
    visible: true,
  };
};
